<template lang='pug'>
.articleStory-top--governmentStyle
  h3.articleStory-title--governmentStyle {{ info.title }}
</template>

<script>
export default {
  props: {
    info: Object,
    staticData: Object
  },
  computed: {
    url() {
      var lengthLimit = 50
      if (this.info.url && this.info.url.length > lengthLimit)
        return this.info.url.substring(0, lengthLimit) + "..."
      return this.info.url
    }
  }
}
</script>